import { useState } from "react";
import { Cookie } from "lucide-react";

const KEY = "hec_cookie_ack";

export default function CookieBanner() {
  const [visible, setVisible] = useState(() => {
    try { return !localStorage.getItem(KEY); } catch { return false; }
  });
  if (!visible) return null;
  const accept = () => {
    try { localStorage.setItem(KEY, new Date().toISOString()); } catch { /* noop */ }
    setVisible(false);
  };
  return (
    <div className="fixed bottom-0 inset-x-0 z-[60] p-3 sm:p-4" data-testid="cookie-banner">
      <div className="max-w-3xl mx-auto rounded-xl bg-[#0b2545] border border-[#14B8A6]/40 shadow-2xl p-4 flex flex-col sm:flex-row items-start sm:items-center gap-3">
        <Cookie className="w-5 h-5 text-[#14B8A6] flex-shrink-0 hidden sm:block" />
        <p className="text-xs text-[#A9D6E5] leading-relaxed flex-1">
          Questo sito utilizza <b className="text-white">solo cookie e memorizzazione tecnica</b> necessari al funzionamento (es. salvataggio bozza). Nessuna profilazione, nessun tracciamento pubblicitario.{" "}
          <a href="/privacy" className="underline text-white hover:text-[#14B8A6]" data-testid="cookie-banner-privacy-link">Informativa Privacy</a>
          {" · "}
          <a href="/cookie" className="underline text-white hover:text-[#14B8A6]" data-testid="cookie-banner-cookie-link">Cookie Policy</a>
        </p>
        <button onClick={accept}
          className="px-5 py-2 rounded-lg bg-[#14B8A6] text-[#06222b] text-xs font-bold hover:bg-[#0d9488] hover:text-white transition-colors flex-shrink-0"
          data-testid="cookie-banner-accept">
          Ho capito
        </button>
      </div>
    </div>
  );
}
